import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useLogin } from '../context/LoginContext'
import { useSpecialty } from '../context/SpecialtiesContext'

import TableData from '../components/common/TableData'
import TitleBox from '../components/common/TitleBox'
import ContainerBox from '../components/common/ContainerBox'
import Modal from '../components/common/Modal'
import Button from '../components/common/Button'
import { IconEdit, IconPlus, IconTrash } from '../components/icons/Icons'
import SpecialtiesForm from '../components/forms/SpecialtiesForm'

const EspecialidadesPage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [idData, setIdData] = useState(null);
    const navigate = useNavigate()
    const { user } = useLogin();
    const { specialties, getSpecialties, modal, getModal } = useSpecialty()

    useEffect(() => {
        if (user !== null) {
            navigate('/especialidades')
        }
        getSpecialties()
    }, [user])

    const openModal = (id = null) => {
        setIsModalOpen(true);
        setIdData(id)
        getModal()
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const columns = [
        {
            header: '#',
            cell: ({ cell }) => {
                const { row } = cell;
                return <div>{row.index + 1}</div>
            }
        },
        {
            header: 'Especialidad',
            accessorKey: 'name'
        },
        {
            header: 'Acciones',
            cell: ({ cell }) => {
                const id = cell.row.original.id
                return <div className='flex items-center'>
                    <button
                        className="bg-warning/80 hover:bg-warning border border-warning/80 text-xs text-black/50 px-3 py-1 rounded-sm"
                        title='Editar'
                        onClick={() => openModal(id)}
                    >
                        <IconEdit className='w-4' />
                    </button>
                    <button
                        className="bg-danger/90 hover:bg-danger border border-danger/90 text-xs text-white px-3 py-1 rounded-sm"
                        title='Eliminar'
                        onClick={openModal}
                    >
                        <IconTrash className='w-4' />
                    </button>
                </div>
            }
        },
    ]

    return (
        <>
            <TitleBox title='Relación de especialidades' />
            <ContainerBox>
                <Button value='Nuevo' openModal={() => openModal()}>
                    <IconPlus className='w-4' />
                </Button>
                <TableData columns={columns} data={specialties} />
            </ContainerBox>
            <Modal
                isOpen={isModalOpen}
                onClose={closeModal}
                isModal={modal}
                title={"Nuevo registro"}
                modalSize='sm'
            >
                <SpecialtiesForm idData={idData} />
            </Modal>
        </>
    )
}

export default EspecialidadesPage